import { injectGlobal, keyframes } from 'styled-components'

const transitionClassName = 'fade'
const duration = 450

const appearOut = keyframes`
	0% { opacity: 1.0;  }
	25% { opacity: .5; }
	100% { opacity: 0; }
`
const appearIn = keyframes`
	0% { opacity: 0; } 
	75% { opacity: .5; }
	100% { opacity: 1; }
`

injectGlobal`
	.${transitionClassName}-exit-active {
		animation: ${appearOut} ${duration}ms both ease-in;
	}
	.${transitionClassName}-enter-active {
		animation: ${appearIn} ${duration}ms both ease;
	}
`

export default { transition: transitionClassName, duration }